// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import request from "./utils/request";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import isMobile from '../static/isMobile'
import Print from 'vue-print-nb'
 
Vue.use(Print);
Vue.prototype.$isMobile = isMobile // 用$与组件内自定义的函数区分，其他符号也可以
Vue.use(preview)
Vue.config.productionTip = false
Vue.prototype.$request=request;
Vue.prototype.$http = request.http; //promise方式的request

import './assets/css/animate.css'
import './assets/css/animate.min.css'
export const setTitle = function(title) {
  title = title ? `${title}` : ''
  window.document.title = title
}
router.afterEach(() => {
  var browserHeaderTitle = '';
    if(sessionStorage.getItem('nm')){
      browserHeaderTitle = sessionStorage.getItem('nm')+'网上报名';
    }else{
      browserHeaderTitle = '网上报名';
    }
    setTitle(browserHeaderTitle)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js